import { Client } from "@core/Client";
import { setTextFontScaledToBox } from "@core/Utils/HelperFunction";
import { Language, Messages } from "../Language";

export class HistoryDialog {
    public historyBackButton: Phaser.GameObjects.Image;
    public historyForwardButton: Phaser.GameObjects.Image;

    private snapshotTexture: Phaser.GameObjects.RenderTexture;
    private graphics: Phaser.GameObjects.Graphics;
    private historyTitle: Phaser.GameObjects.Text;
    private gameTitle: Phaser.GameObjects.Text;
    private winsText: Phaser.GameObjects.Text;
    private repeatGameText: Phaser.GameObjects.Text;
    private exitHistoryButton: Phaser.GameObjects.Image;
    private repeatGameButton: Phaser.GameObjects.Image;

    private staticWidth: number = 0;
    private staticHeight: number = 0;
    private portraitMode = false;

    private winTimeout: any;

    constructor(private scene: Phaser.Scene, spritesheet: string, buttonBackFrame: string, buttonExitFrame: string, repeatGameFrame: string, fontStyle) {
        let blockInput = (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
            event.stopPropagation();
        }
        this.graphics = this.scene.add.graphics();
        this.graphics.setInteractive(new Phaser.Geom.Rectangle(0, 0, this.scene.scale.width, this.scene.scale.height), Phaser.Geom.Rectangle.Contains);
        this.graphics.on("pointerup", blockInput);
        this.graphics.on("pointerdown", blockInput);

        this.snapshotTexture = this.scene.add.renderTexture(0, 0, 64, 64).setOrigin(0.5);
        this.historyTitle = this.scene.add.text(0, 0, Language.Get(Messages.HISTORY_VIEW_TITLE), fontStyle).setOrigin(0.5);
        this.gameTitle = this.scene.add.text(0, 0, "", fontStyle).setOrigin(0.5);
        this.winsText = this.scene.add.text(0, 0, "", fontStyle).setOrigin(0.5);
        this.repeatGameText = this.scene.add.text(0, 0, Language.Get(Messages.REPEAT_THIS_GAME), fontStyle).setOrigin(0, 0.5);

        this.repeatGameButton = this.scene.add.image(0, 0, spritesheet, repeatGameFrame).setOrigin(0.5);
        this.repeatGameButton.setInteractive();
        this.repeatGameButton.on("pointerup", () => {
            Client.logic.HideHistoryAndRepeatSelectedGame();
            this.Hide();
        });

        this.exitHistoryButton = this.scene.add.image(0, 0, spritesheet, buttonExitFrame).setOrigin(0.5);
        this.exitHistoryButton.setInteractive();
        this.exitHistoryButton.on("pointerup", () => {
            Client.logic.hideHistoryReplay();
            this.Hide();
        });

        this.historyBackButton = this.scene.add.image(0, 0, spritesheet, buttonBackFrame).setOrigin(0.5);
        this.historyBackButton.setInteractive();

        this.historyForwardButton = this.scene.add.image(0, 0, spritesheet, buttonBackFrame).setOrigin(0.5);
        this.historyForwardButton.setInteractive();

        this.historyForwardButton.flipX = true;

        this.repeatGameText.visible = this.repeatGameButton.visible = this.graphics.visible = this.snapshotTexture.visible = this.historyTitle.visible = this.gameTitle.visible = this.winsText.visible = this.exitHistoryButton.visible = this.historyBackButton.visible = this.historyForwardButton.visible = false;
    }

    public UpdatePositions(portraitMode, staticWidth: number, staticHeight: number) {
        this.portraitMode = portraitMode;
        this.staticWidth = staticWidth;
        this.staticHeight = staticHeight;

        this.graphics.clear();
        this.graphics.fillStyle(0x000000, 0.75);

        if (this.portraitMode) 
            this.graphics.fillRect(0, -this.staticHeight, staticWidth, staticHeight);
        else
            this.graphics.fillRect(0, 0, staticWidth, staticHeight);

        let leftoverWidth = (staticWidth / 10) * 1.5;
        let leftoverHeight = (staticHeight / 10) * 1.5;
        let buttonSize = Math.min(leftoverWidth, leftoverHeight) * 0.9;

        if (Client.logic.setup.GameHistory.length > 0) {
            this.historyTitle.text = Language.Get(Messages.HISTORY_VIEW_TITLE);
            setTextFontScaledToBox(this.historyTitle, (staticWidth - buttonSize) * 0.9, (leftoverHeight / 2) * 0.9);
            this.historyTitle.setPosition(staticWidth / 2, leftoverHeight / 4);
        
            this.gameTitle.text = Language.Get(Messages.SHOWING_HISTORY) + " " + (Client.logic.setup.GameHistory.length - Client.logic.currentHistorySnapshotIndex) + " " + Language.Get(Messages.GAMES_AGO) + " " + new Date(Client.logic.lastGameSnapshot.endT).toLocaleString(Language.locale);
            setTextFontScaledToBox(this.gameTitle, (staticWidth - buttonSize) * 0.9, (leftoverHeight / 4) * 0.9);
            this.gameTitle.setPosition(staticWidth / 2, leftoverHeight / 2 + leftoverHeight / 8);
        }

        if(this.portraitMode)
        {
            this.historyTitle.setPosition(staticWidth / 2, leftoverHeight / 4 -this.staticHeight);
            this.gameTitle.setPosition(staticWidth / 2, leftoverHeight / 2 + leftoverHeight / 8 - this.staticHeight);
        } else {
            this.historyTitle.setPosition(staticWidth / 2, leftoverHeight / 4);
            this.gameTitle.setPosition(staticWidth / 2, leftoverHeight / 2 + leftoverHeight / 8);
        }

        let wins = this.winsText.text;
        this.winsText.text = "00000000000000000000000000000000000000000000000000000";
        setTextFontScaledToBox(this.winsText, (staticWidth - buttonSize) * 0.9, (leftoverHeight / 4) * 0.9);
        this.winsText.text = wins;
        this.winsText.setPosition(staticWidth / 2, leftoverHeight - leftoverHeight / 8);

        this.exitHistoryButton.setDisplaySize(buttonSize, buttonSize);
        this.exitHistoryButton.setPosition(staticWidth - buttonSize, leftoverHeight / 2);

        this.historyForwardButton.setDisplaySize(this.exitHistoryButton.displayWidth, staticHeight);
        this.historyForwardButton.setScale(Math.min(this.historyForwardButton.scaleX, this.historyForwardButton.scaleY));
        this.historyForwardButton.setPosition(staticWidth - leftoverWidth / 2, staticHeight / 2);

        this.historyBackButton.scale = this.historyForwardButton.scale;
        this.historyBackButton.setPosition(leftoverWidth / 2, staticHeight / 2);

        if (this.snapshotTexture) {
            this.snapshotTexture.setDisplaySize(staticWidth * 0.7, staticHeight * 0.7);
            this.snapshotTexture.setScale(Math.min(this.snapshotTexture.scaleX, this.snapshotTexture.scaleY));

            if (this.portraitMode)
                this.snapshotTexture.setPosition(staticWidth / 2, staticHeight / 2 - this.staticHeight);
            else
                this.snapshotTexture.setPosition(staticWidth / 2, staticHeight / 2);
        }

        this.repeatGameButton.setDisplaySize(buttonSize, buttonSize);
        this.repeatGameButton.setPosition(staticWidth / 2, staticHeight - leftoverHeight / 2);

        this.repeatGameText.text = Language.Get(Messages.REPEAT_THIS_GAME);
        setTextFontScaledToBox(this.repeatGameText, (staticWidth / 2) * 0.9, (leftoverHeight / 4) * 0.9);
        this.repeatGameText.setPosition(staticWidth / 2 + ((this.repeatGameButton.displayWidth / 2) * 1.1), this.repeatGameButton.y);

        if (this.portraitMode) {
            this.winsText.y -= this.staticHeight;
            this.exitHistoryButton.y -= this.staticHeight;
            this.historyForwardButton.y -= this.staticHeight;
            this.historyBackButton.y -= this.staticHeight;
            this.repeatGameButton.y -= this.staticHeight;
            this.repeatGameText.y -= this.staticHeight;
        }

    }

    public Show(gameObjectsToSnapshot: Array<Phaser.GameObjects.GameObject>): void {
        let width = this.staticWidth;
        let height = this.staticHeight;

        this.graphics.clear();
        this.graphics.fillStyle(0x000000, 0.8);
        this.graphics.fillRect(0, 0, width, height);

        if (!this.snapshotTexture) {
            this.snapshotTexture = this.scene.add.renderTexture(0, 0, width, height).setOrigin(0.5);
        }

        this.snapshotTexture.clear();
        this.snapshotTexture.setSize(width, height);
        if (this.portraitMode) {
            gameObjectsToSnapshot.forEach(element => {
                if (element instanceof Phaser.GameObjects.Container) {
                    this.snapshotTexture.draw(element, undefined, height - (element.x+element.height));
                } else {
                    this.snapshotTexture.draw(element, undefined, 0);
                }
            });
        }
        else
            this.snapshotTexture.draw(gameObjectsToSnapshot);

        this.snapshotTexture.setScale(0.7);

        if (this.portraitMode)
            this.snapshotTexture.setPosition(width / 2, height / 2 - height);
        else
            this.snapshotTexture.setPosition(width / 2, height / 2);

        if (Client.logic.HistorySnapshots.length == 1 || Client.logic.CurrentHistorySnapshotIndex == 0) {
            this.historyBackButton.setTint(0x666666);
            this.historyBackButton.disableInteractive();
        }
        else if (this.historyBackButton.isTinted) {
            this.historyBackButton.clearTint();
            this.historyBackButton.setInteractive();
        }

        if (Client.logic.HistorySnapshots.length == 1 || Client.logic.CurrentHistorySnapshotIndex == Client.logic.HistorySnapshots.length - 1) {
            this.historyForwardButton.setTint(0x666666);
            this.historyForwardButton.disableInteractive();
        }
        else if (this.historyForwardButton.isTinted) {
            this.historyForwardButton.clearTint();
            this.historyForwardButton.setInteractive();
        }

        this.historyTitle.text = Language.Get(Messages.HISTORY_VIEW_TITLE);
        this.gameTitle.text = Language.Get(Messages.SHOWING_HISTORY) + (Client.logic.setup.GameHistory.length - Client.logic.currentHistorySnapshotIndex) + " " + Language.Get(Messages.GAMES_AGO) + " " + new Date(Client.logic.lastGameSnapshot.endT).toLocaleString(Language.locale);

        clearTimeout(this.winTimeout);

        let historyText = Client.logic.bets.calculateHistoricWinsText(Client.logic.lastGameSnapshot.randoms[0], Client.logic.BetFields);
        let readyForDisplayText: Array<string> = new Array<string>();
        let str = "";

        historyText.forEach((text, index) => {
            if (str.length + 7 + text.length > 90) {
                readyForDisplayText.push(str);
                str = "";
            }
            else if (str.length > 0)
                str += "   |   ";

            str += text;

            if (historyText.length == (index + 1))
                readyForDisplayText.push(str);
        });

        if (readyForDisplayText.length == 1) {
            this.winsText.text = readyForDisplayText[0];
        } else {
            let i = 1;
            this.winsText.text = readyForDisplayText[0];
            this.winTimeout = setInterval(function () {
                this.winsText.text = readyForDisplayText[i];
                i++;
                if (i >= readyForDisplayText.length)
                    i = 0;
            }.bind(this), 3000);
        }

        this.repeatGameText.visible = this.repeatGameButton.visible = this.graphics.visible = this.snapshotTexture.visible = this.historyTitle.visible = this.gameTitle.visible = this.winsText.visible = this.exitHistoryButton.visible = this.historyBackButton.visible = this.historyForwardButton.visible = true;

        this.scene.children.bringToTop(this.graphics);
        this.scene.children.bringToTop(this.snapshotTexture);
        this.scene.children.bringToTop(this.historyTitle);
        this.scene.children.bringToTop(this.gameTitle);
        this.scene.children.bringToTop(this.winsText);
        this.scene.children.bringToTop(this.exitHistoryButton);
        this.scene.children.bringToTop(this.historyBackButton);
        this.scene.children.bringToTop(this.historyForwardButton);
        this.scene.children.bringToTop(this.repeatGameButton);
        this.scene.children.bringToTop(this.repeatGameText);

        this.UpdatePositions(this.portraitMode, this.staticWidth, this.staticHeight);

        Client.logic.UpdateFlags(true, "historypages", true);
    }

    public Hide(): void {
        clearTimeout(this.winTimeout);
        this.repeatGameText.visible = this.repeatGameButton.visible = this.graphics.visible = this.snapshotTexture.visible = this.historyTitle.visible = this.gameTitle.visible = this.winsText.visible = this.exitHistoryButton.visible = this.historyBackButton.visible = this.historyForwardButton.visible = false;
        this.snapshotTexture.clear();

        Client.logic.UpdateFlags(false, "historypages", true);
    }
}